import { useActionContext } from '@/store/contexts/ActionContext'

/**
 * Action 관련 Custom Hook
 * ActionContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useAction() {
  return useActionContext()
}

